import React from 'react';

export const TCG_TYPES = [
  { key: 'pokemon', label: 'Pokémon', color: '#FFCB05', bg: 'from-[#FFCB05]/20 to-[#3B4CCA]/20' },
  { key: 'magic', label: 'Magic: The Gathering', color: '#8B5CF6', bg: 'from-[#8B5CF6]/20 to-[#1e1e2e]/20' },
  { key: 'yugioh', label: 'Yu-Gi-Oh!', color: '#F59E0B', bg: 'from-[#F59E0B]/20 to-[#7C3AED]/20' },
  { key: 'onepiece', label: 'One Piece', color: '#EF4444', bg: 'from-[#EF4444]/20 to-[#1e40af]/20' },
  { key: 'riftbound', label: 'Riftbound', color: '#0BC4E2', bg: 'from-[#0BC4E2]/20 to-[#1e1e2e]/20' },
];

export default function TCGSelector({ selectedTcg, onSelect }) {
  return (
    <div className="flex flex-wrap gap-3 mb-6">
      {TCG_TYPES.map(tcg => (
        <button
          key={tcg.key}
          onClick={() => onSelect(tcg.key)}
          className={`px-5 py-2.5 rounded-xl text-sm font-semibold transition-all ${
            selectedTcg === tcg.key
              ? `bg-gradient-to-r ${tcg.bg} border-2`
              : 'bg-[#12121A] border border-white/5 hover:border-white/20'
          }`}
          style={{ 
            borderColor: selectedTcg === tcg.key ? tcg.color : undefined,
            color: selectedTcg === tcg.key ? tcg.color : '#A1A1AA'
          }}
          data-testid={`tcg-btn-${tcg.key}`}
        >
          {tcg.label}
        </button>
      ))}
    </div>
  );
}
